import { Modal } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

export default function OrdersGridVariantsModal({
  isOpen,
  handleClose,
  handleCancel,
  handleOkVariantsModal,
  variants,
}) {
  const [selectedOptionId, setSelectedOptionId] = useState(
    variants.length > 1 ? variants[0].optionId : ""
  );

  const onChange = (e) => {
    setSelectedOptionId(e.target.value);
  };

  const onHandleAdd = () => {
    console.log('========onHandleAdd=======called');
    handleOkVariantsModal(selectedOptionId);
  };
  
  useEffect(() => {
    setSelectedOptionId(variants.length > 1 ? variants[0].optionId : "")
  }, [variants])

  return (
    <Modal
      open={isOpen}
      footer={[
        <div
          key="footer-btns"
          className="flex gap-x-5 justify-center py-[58px]"
        >
          <button
            key="cancel-btn"
            onClick={handleCancel}
            className="bg-[#FCBD10] text-black text-[14px] font-bold leading-[16px] w-[100px] h-[42px] rounded-[5px]"
          >
            Cancel
          </button>
          <button
            key="add-btn"
            onClick={onHandleAdd}
            className="bg-[#2EC114] text-white text-[14px] font-bold leading-[16px] w-[100px] h-[42px] rounded-[5px]"
          >
            Add
          </button>
        </div>,
      ]}
      onCancel={handleClose}
      width={550}
      style={{ padding: "40px" }}
      className="add-ons-modal"
      okText="Add"
      cancelText="Cancel"
      title={
        <h1 className="uppercase bg-[#E5E5E5] py-5 pl-[30px]">Variants</h1>
      }
      destroyOnClose={true}
      closeIcon={<CloseCircleOutlined className="text-black text-[24px]" />}
    >
      <section className="min-h-[50px] bg-white mt-[42px]">
        <div className="flex flex-col gap-2">
          {variants.map((item) => (
            <label
              key={item.optionId}
              className="flex items-center block w-full p-3 border rounded-lg cursor-pointer hover:bg-gray-50"
            >
              <div className="flex-shrink-0 flex items-center h-full">
              <input
                type="radio"
                name="my-radio-group"
                value={item.optionId}
                checked={selectedOptionId === item.optionId}
                onChange={onChange}
                className={`
                          mr-3
                          w-5 h-5 
                          appearance-none 
                          rounded-full border border-gray-400 
                          checked:bg-blue-600 
                          checked:border-blue-600
                          transition-colors duration-200
            `}
              />
              </div>
              <div className="flex justify-between items-center flex-grow gap-4 min-w-0">
                <div className="break-all whitespace-normal truncate-0 min-w-0">{item.name}</div>
                <div className="shrink-0">{item.currentPrice.toFixed(2)} TK</div>
              </div>
            </label>
          ))}
        </div>
      </section>
    </Modal>
  );
}
